import React from "react"

import { css } from "@emotion/react"
import { Collapse } from "antd"

import type { AvailableTextTypography } from "@front-shared/types/elements.types.ts"

import { PrimaryText } from "./primaryText.element"

import expandIcon from "@front-shared/assets/images/icons/expand.svg"

export const CollapseElement: React.FunctionComponent<
    ICollapseElementProps
> = props => {
    return (
        <Collapse
            className={props.className}
            accordion={props.isAccordion}
            defaultActiveKey={props.firstDefaultOpen ? 0 : undefined}
            expandIconPosition="end"
            expandIcon={panelProps => {
                return (
                    <img
                        src={expandIcon}
                        alt="Expand"
                        css={
                            panelProps.isActive
                                ? styles.activePanelIcon
                                : undefined
                        }
                    />
                )
            }}
        >
            {props.titles.map((item, key) => (
                <Collapse.Panel
                    header={
                        <div className="flex items-center">
                            {item.icon && (
                                <div css={styles.headerIcon}>
                                    <img src={item.icon} alt="Header Icon" />
                                </div>
                            )}

                            <PrimaryText
                                typography={props.titleTypography || "h6"}
                            >
                                {item.text}
                            </PrimaryText>
                        </div>
                    }
                    key={key}
                >
                    <PrimaryText typography={props.contentTypography || "text"}>
                        {props.contents[key] || "No content"}
                    </PrimaryText>
                </Collapse.Panel>
            ))}
        </Collapse>
    )
}

const styles = {
    activePanelIcon: css({
        transform: "rotate(90deg) translateY(-50%) !important",
        marginTop: "-6px !important",
        right: "22px !important",
    }),
    headerIcon: css({
        marginRight: 8,
    }),
}

interface ICollapseElementProps {
    className?: string
    titles: {
        icon?: string
        text: string | React.JSX.Element
    }[]
    titleTypography?: AvailableTextTypography
    contents: React.JSX.Element[]
    contentTypography?: AvailableTextTypography
    isAccordion?: boolean
    firstDefaultOpen?: boolean
}
